export function trackMetaPixelEvent(event) {
  if (window && window.fbq) {
    try {
      window.fbq('track', event);
    } catch (error) {
      console.error("Error tracking fbq", error);
    }
  }
}